//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DetailTopPart from "./components/DetailTopPart";
import OrderLand from "./components/OrderLand";
export default {
  name: "FarmingOrderSettleDetail",
  components: {
    DetailTopPart,
    OrderLand,
  },
  data() {
    return {
      id: "",
      from_type: "",
    };
  },
  mounted() {
    let { id, from_type } = this.$route.query;
    this.id = id;
    this.from_type = from_type;
  },
};
